import Permissions from "./permissions";

export default Permissions;